import { SEGMENT_ANONYMOUS_ID_COOKIE } from "@/constants/cookies";

export const segmentSnippet = `
  !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);
  var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);
  t.src = (n && n.cdnURL ? n.cdnURL : "https://cdn.segment.com") + "/analytics.js/v1/" + key + "/analytics.min.js";
  var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}";;analytics.SNIPPET_VERSION="5.2.0";
  analytics.load("${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}", {
    //cdnURL to explicitly tell Segment where to load analytics.js from
    cdnURL: 'https://sc.nutrafol.com', 
    integrations: {
      'segment.io': {
        // Tracking API endpoint, where data is sent
        host: 'https://sa.nutrafol.com'
      }
    }
  });
  /*
   * Pre-seed anon id before analytics.js / GTM Init:
   * - Nutrafol cookie segment_anonymous_id (GTM / marketing)
   * - analytics.setAnonymousId on the stub so the SDK adopts this id on load
   * - Read ajs_anonymous_id only as fallback; Segment owns writing ajs_*
   */
  (function(){
    try {
      var nutraName='${SEGMENT_ANONYMOUS_ID_COOKIE}';
      var ajsName='ajs_anonymous_id';
      var getCookie=function(n){
        var eq=n+'=';
        var ca=document.cookie.split(';');
        for(var j=0;j<ca.length;j++){
          var c=ca[j];
          while(c.charAt(0)===' ')c=c.substring(1,c.length);
          if(c.indexOf(eq)===0)return decodeURIComponent(c.substring(eq.length,c.length));
        }
        return null;
      };
      var normalizeId=function(v){
        if(!v)return null;
        try{
          var parsed=JSON.parse(v);
          if(typeof parsed==='string'&&parsed)return parsed;
        }catch(e){}
        v=String(v).replace(/^"|"$/g,'');
        return v||null;
      };
      var writeNutraCookie=function(anonId){
        var d=new Date();
        d.setTime(d.getTime()+30*24*60*60*1000);
        document.cookie=nutraName+'='+encodeURIComponent(anonId)+';expires='+d.toUTCString()+';path=/'+(location.protocol==='https:'?';secure':'');
      };
      var id=normalizeId(getCookie(nutraName));
      if(!id)id=normalizeId(getCookie(ajsName));
      if(!id){
        try{
          id=normalizeId(window.localStorage&&window.localStorage.getItem(ajsName));
        }catch(e){}
      }
      if(!id){
        id=(typeof crypto!=='undefined'&&crypto.randomUUID)
          ? crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(ch){
              var r=Math.random()*16|0;
              var v=ch==='x'?r:(r&0x3|0x8);
              return v.toString(16);
            });
      }
      writeNutraCookie(id);
      if(typeof analytics.setAnonymousId==='function'){
        analytics.setAnonymousId(id);
      }else if(Array.isArray(analytics)){
        analytics.push(['setAnonymousId',id]);
      }
    }catch(e){}
  })();
  }}();
`;
